class SizePage extends HTMLElement {
  toggleSwitch?: HTMLElement | null;
  activeMeasurement: "cm" | "inches" = "cm";

  connectedCallback() {
    console.log("hello world");
    this.toggleSwitch = this.querySelector(".toggle-switch");
    this.toggleSwitch?.addEventListener("click", this.toggleCmInch.bind(this));
    this.toggleRows = this.toggleRows.bind(this);

    this.toggleRows();
  }

  toggleRows() {
    const allRows = Array.from(this.querySelectorAll("tr"));
    allRows.forEach((row) => {
      const isCm = row.classList.contains("cm");
      const isInches = row.classList.contains("inches");

      if (this.activeMeasurement === "cm") {
        if (isCm) row.style.display = "table-row";
        if (isInches) row.style.display = "none";
      }

      if (this.activeMeasurement === "inches") {
        if (isCm) row.style.display = "none";
        if (isInches) row.style.display = "table-row";
      }
    });
  }

  toggleCmInch() {
    this.toggleSwitch?.classList.toggle("active");
    this.activeMeasurement = this.activeMeasurement === "cm" ? "inches" : "cm";
    this.toggleRows();
  }
}

customElements.define("size-page", SizePage);
